class LoanApi {
    getListByCurrentBusiness() {
        return api.call('get', apiUrl + 'loans/currentBusiness/')
            .then(({ data }) => data);
    }
    get(id) {
        return api.call('get', apiUrl + 'loans/' + id)
            .then(({ data }) => data);
    }
    create(data) {
        return api.call('post', apiUrl + 'loans', data)
            .then(({ data }) => data);
    }
    update(data) {
        return api.call('put', apiUrl + 'loans/' + data.id, data)
            .then(({ data }) => data);
    }
    delete(id) {
        return api.call('delete', apiUrl + 'loans/' + id)
            .then(({ data }) => data);
    }
}

export default LoanApi;
